import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import {FORM_ROOM_TYPES_NAME} from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './HotelContentWedding.scss'
import TextAreaInput from '../../../atoms/form/TextAreaInput/TextAreaInput'
import HotelContentService from 'services/HotelContentService'
import Table from "../../../molecules/Table/Table";

class HotelContentWedding extends Component {
    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        if (!hotelCode || !hotelInfo) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }
        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            error: undefined,
            isLoading: true,
            continueFlow: this.props.history.location?.state?.continueFlow,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            initialValues: { ...this.initialValues },
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    initialValues = {
        typeCode : "WEDDING",
        contentId: undefined,
        businessName: "",
        shortDescription: "",
        phoneCountryCode: "",
        phoneAreaCode: "",
        phoneNumber: "",
		serviceUrl: "",
		websiteUrl: "",
        details : [ 
            
        ]
    }

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            await HotelContentService.getHotelContents({ hotelCode: this.state.hotelCode, queryParams: {typeCode: 'WEDDING'} })
            .then(response => {
                if (!response?.error) {
                    let initialValues = { ...this.state.initialValues }
                    let weddingData = initialValues;
                    if (!response?.error) {
                        response.forEach(hotelContent => {
                            if (hotelContent.details !== undefined)
                                hotelContent.details.forEach(detail => {
                                        hotelContent[detail.name] = detail.value;
                                    }
                                )
                            weddingData = hotelContent;
                        })
                        this.setState({ initialValues: {...weddingData}, error: undefined, isLoading: false })
                    } else {
                        this.setState({ isLoading: false })
                    }
                } else {
                    this.setState({ isLoading: false })
                }
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while reading Hotel Content Wedding data'
                })
            });
        } else {
            await HotelContentService.getHotelContents({ hotelCode: this.state.hotelCode, queryParams: {typeCode: 'WEDDING'} })
                .then(response => {
                    let initialValues = { ...this.state.initialValues }
                    let weddingData = initialValues;
                    if (!response?.error) {
                        response.forEach(hotelContent => {
                            if (hotelContent.details !== undefined)
                                hotelContent.details.forEach(detail => {
                                        hotelContent[detail.name] = detail.value;
                                    }
                                )
                            weddingData = hotelContent;
                        })
                        this.setState({ initialValues: {...weddingData}, error: undefined, isLoading: false })
                    } else {
                        this.setState({ isLoading: false })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading Hotel Content Wedding data'
                    })
                });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    error: this.props.errorMessage,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    showUpdateModal: false,
                    isLoading: false 
                })
            } else {
                if (this.state.actionPerformed === FormConst.ACTION_SAVE_AND_PROCEED) {
                    this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
                } else {
                    this.setState({
                        isLoading: false,
                        showUpdateModal: false,
                        errorMessage: undefined,
                        alertEditIndex: -1,
                        showNewWeddingFields: false 
                    })
                }
            }
        }
    }

    async handleSubmit(formData) {
        let data = structuredClone(formData);
        //We have to massage the details data given the structure is not something the form can replicate.
        let details = [];
        if (data.serviceUrl) {
            details.push({name: "serviceUrl", value: data.serviceUrl });
        }
        if (data.websiteUrl) {
            details.push({name: "websiteUrl", value: data.websiteUrl });
        }
        data.details = details;
        //Given Phone Number is optional, we need to null the values if empty.
        if (data.phoneCountryCode == '') data.phoneCountryCode = null;
        if (data.phoneAreaCode == '') data.phoneAreaCode = null;
        if (data.phoneNumber == '') data.phoneNumber = null;
        //Send data to HDS
        if (data.contentId) {
            await this.props.onPut({ hotelCode: this.state.hotelCode, formData: data });
            this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
        } else {
            await HotelContentService.putHotelContent({ hotelCode: this.state.hotelCode, formData: data }).then(response => {
                HotelContentService.getHotelContents({ hotelCode: this.state.hotelCode, queryParams: {typeCode: 'wedding'} })
                .then(response => {
                    this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading Hotel Content Wedding data'
                    })
                });
            })
        }
    }
    
    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    async handleDelete () {
        let data = { contentId : this.state.initialValues.contentId }
        await HotelContentService.deleteHotelContent({ hotelCode: this.state.hotelCode, formData: data }).then(response => {
            this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
        }).catch(error => {
            this.setState({
               isLoading: false,
               showErrorModal: true,
               errorMessage: 'There was an error while reading Hotel Content Wedding data'

            })
        });
    }

    discardNewFields = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: RouteConst.ROUTE_HOTEL_CONTENT_PAGE,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Hotel Content page
            this.props.history.push(RouteConst.ROUTE_HOTEL_CONTENT_PAGE)
        }
    }

    validationSchema = Yup.object().shape({
        businessName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED).max(120, `Maximum 120 characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        shortDescription: Yup.string().max(FormConst.MAX_LENGTH_SHORT_DESCRIPTION, `Maximum ${FormConst.MAX_LENGTH_SHORT_DESCRIPTION} characters`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS).required(FormConst.VALIDATION_ERROR_REQUIRED),
        phoneCountryCode: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .length(2, `Must be 2 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneAreaCode || !!this.parent.phoneNumber) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        phoneAreaCode: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .length(3, `Must be 3 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneCountryCode || !!this.parent.phoneNumber) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        phoneNumber: Yup.string()
            .matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .length(10, `Must be 10 digits`).test('detailedLocation', 
                function(val) {
                    if ((!!this.parent.phoneAreaCode || !!this.parent.phoneCountryCode) && !val) {
                        return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
                    }
                    return true;
                }
            ),
        serviceUrl: Yup.string().max(240, 'Max length 240 characters')
            .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
        websiteUrl: Yup.string()
            .max(240, 'Max length 240 characters')
            .matches(FormConst.URL_PATTERN, FormConst.VALIDATION_ERROR_URL_FORMAT),
    })

    render() {
        let navOption = RouteConst.ROUTE_POLICIES_PAGE;
        let navTitle = "Hotel Policies";
        let navDirection = "Proceed to Hotel Policies";
        return (
            <div className='hotel-content-wedding-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOTEL_CONTENT_PAGE}>Hotel Content</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Wedding</li>
                    </ol>
                </nav>
                
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                        resetForm()
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form id="hotelContentWeddingForm" className='hotel-content-wedding-form-element'>
                            <p>This section lets you provide detailed information about your onsite wedding options. You can highlight specific services and offerings in the meeting rooms section to make your hotel more appealing to potential wedding clients.</p>
                            <div id='hotel-content-wedding-form-fields' className={`hotel-content-wedding-form-fields ${this.state.shouldHideEditAreaClassName}`}>
                                <Row className='leftAlignRow'>
                                    <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                        <TextInput id='businessName' name='businessName' type='text' label='Name' isrequired='true' />
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 5, offset: 0 }}>
                                    
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 20, offset: 0 }} className="shortDescriptionArea">
                                        <p className='helper-text'>Short Description*</p>
                                        <TextAreaInput
                                            id='short-description-text-area'
                                            name='shortDescription'
                                            maxLength={FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription}
                                            rows={10}
                                            isrequired='true'
                                            title='Short Description' />
                                        <p className='float-right'>Characters left: {FormConst.HOTEL_CONTENT_TYPE_MAX_CHARACTER_LIMIT.shortDescription - values.shortDescription.length}</p>
                                    </Col>
                                </Row>
                                <p className='caption'>Contact Details</p>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput
                                            id='wedding-phone-number'
                                            name='phoneCountryCode'
                                            type='tel'
                                            label='Phone Number'
                                            placeholder='CC'
                                            title='Country Code'
                                            suffix={
                                                <>
                                                    <TextInput
                                                        id='area-code'
                                                        name='phoneAreaCode'
                                                        type='num'
                                                        label=' - '
                                                        title='Area Code'
                                                        placeholder='Area Code' />
                                                    <TextInput
                                                        id='phone-number'
                                                        name='phoneNumber'
                                                        type='tel'
                                                        label=' - '
                                                        title='Phone Number'
                                                        placeholder='Number' />
                                                </>
                                            }
                                            isrequired='false' />
                                        </Col>
                                        <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='websiteUrl' name='websiteUrl' type='text' label='Website URL' isrequired='false' />
                                    </Col>
                                    <Col xs={12} sm={12} xl={{ span: 6, offset: 0 }}>
                                        <TextInput id='serviceUrl' name='serviceUrl' type='text' label='Services URL' isrequired='false' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-restaurant-action-button" formNoValidate /></Col>
                                    <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-restaurant-action-button" onClick={() => {
                                            if (dirty) {
                                                this.handleClearForm()
                                            } else {
                                                this.discardNewFields(resetForm)
                                            }
                                        }
                                    }
                                        overridedisabledflag='true' /></Col>
                                    {
                                        this.state.initialValues.contentId
                                        && (
                                            <Col xs={3} sm={2} lg={1}><Button role='link' name={FormConst.DELETE_LINK_TEXT} className="new-restaurant-action-button"
                                                                              onClick={() => this.setState({showDeleteModal: true})} /></Col>
                                        )
                                    }

                                </Row>
                            </div>
                            {
                                this.state.showNewWeddingFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }
                            <FormFooter
                                form={{
                                    previous: { title: 'Hotel Content', route: RouteConst.ROUTE_HOTEL_CONTENT_PAGE },
                                    next: { title: navTitle, route: navOption }
                                }}
                                submitName={this.state.continueFlow ? navDirection : 'Go back to Hotel Content'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewWeddingFields}
                                noReset />
                            <FormModal
                                id='wedding-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='wedding-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='wedding-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Wedding'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.handleDelete()
                                }}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='wedding-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                        )}
                        </Formik>
            </div>
        )
    }
}
// Sample redux diweddingtch
const mapStateToProps = state => {
    return {
        hotelContentResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}
const mapDiweddingtchToProps = diweddingtch => {
    return {
        onGet: (hotelCode) => diweddingtch(asyncMethod(FORM_ROOM_TYPES_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode, 
            queryParams: { typeCode: 'wedding' } })),
        onPut: (data) => diweddingtch(asyncMethod(FormConst.FORM_HOTEL_CONTENT_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
        onDelete: (data) => diweddingtch(asyncMethod(FormConst.FORM_HOTEL_CONTENT_NAME, actionTypes.ASYNC_ACTIONS.DELETE, data))
    }
}
export default connect(mapStateToProps, mapDiweddingtchToProps)(withFormLayout(HotelContentWedding, SideNavEntryMapping.HOTEL_CONTENT));